import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SubCategoriesService {

  constructor(private apiService: ApiService) { }

  getSubCategories(params?: HttpParams) {
    return this.apiService.get('sub_categories',params);
  }

  getSubCategory(id: any) {
    return this.apiService.get(`sub_categories/${id}`);
  }

  createSubCategory(data: any) {
    return this.apiService.post('sub_categories', data);
  }

  deleteSubCategory(id: any) {
    return this.apiService.delete(`sub_categories/${id}`);
  }

  updateSubCategory(id: any, data: any) {
    return this.apiService.update(`sub_categories/${id}`, data);
  }
}
